import { cn } from "@/lib/utils";
import { SERIES_BG, TRACK_BG } from "./opsColors";

/** Five pips for the prospect milestones; `filled` is how many are reached (0 = no stage). */
export function StagePips({ filled, total = 5, label }: { filled: number; total?: number; label: string }) {
  return (
    <span className="inline-flex gap-[2px] align-middle mr-1.5" role="img" aria-label={label} title={label}>
      {Array.from({ length: total }, (_, i) => (
        <span key={i} className={cn("w-2 h-1 rounded-[1px]", i < filled ? SERIES_BG : TRACK_BG)} />
      ))}
    </span>
  );
}
